var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconsLocation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 9.60204C2 4.30171 6.30171 0 11.602 0C16.9024 0 21.2041 4.30171 21.2041 9.60204C21.2041 16.2215 14.0738 21.4149 12.102 22.7246C11.7944 22.9289 11.4097 22.9289 11.1021 22.7246C9.13024 21.4149 2 16.2215 2 9.60204ZM11.6021 14.4031C14.2536 14.4031 16.4031 12.2536 16.4031 9.60208C16.4031 6.95055 14.2536 4.80106 11.6021 4.80106C8.95055 4.80106 6.80106 6.95055 6.80106 9.60208C6.80106 12.2536 8.95055 14.4031 11.6021 14.4031Z",
    fill: "#0A0A13"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsLocation);
export default __webpack_public_path__ + "static/media/iconsLocation.80a69dfe6a64febca8f3478846b296ef.svg";
export { ForwardRef as ReactComponent };